import { Icon } from './Icon';
import { InnerContainer } from './Layout';
import { LogoCare } from './Logo';
import PDPSkeleton from './PDPSkeleton';
import { View } from './Themed';
import IntroSection from './explore/IntroSection';
import Colors from '../constants/Colors';
import { useMaxWidth } from '../hooks/useResponsive';

export function Splash({
  campaignKey,
  pageType = 'unknown',
  isLoggedIn,
}: {
  campaignKey?: string | null;
  pageType?: string;
  isLoggedIn?: boolean;
}) {
  const isMobileDevice = useMaxWidth(768);
  return (
    <View style={{ height: '100%' }}>
      {campaignKey ? <div className="campaign-placeholder" /> : null}
      <div className="header-placeholder shd">
        <InnerContainer
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >
          <div className="logo">
            <LogoCare />
          </div>
          <div className="search shd">
            <Icon name="search" color={Colors.dark.accentTertiary} />
          </div>
          <div className="menu">
            <Icon name="hamburger" />
          </div>
        </InnerContainer>
      </div>

      {pageType === 'home' && !isLoggedIn ? (
        <>
          <InnerContainer
            style={{
              paddingTop: isMobileDevice ? 20 : 50,
            }}
          >
            <IntroSection />
          </InnerContainer>
        </>
      ) : null}
      {pageType === 'location' ? (
        <InnerContainer>
          <PDPSkeleton />
        </InnerContainer>
      ) : null}
    </View>
  );
}
